export const MT = "MT";
export type MT = typeof MT;

export const WT = "WT";
export type WT = typeof WT;

export const VT = "VT";
export type VT = typeof VT;

export const WCT = "WCT";
export type WCT = typeof WCT;

export const BT = "BT";
export type BT = typeof BT;

export const JT = "JT";
export type JT = typeof JT;
